import { useMutation } from "@tanstack/react-query";
import { useClientContext } from "clients";

const useResetPassword = () => {
  const clients = useClientContext();
  return useMutation({
    mutationFn: (email: string) => clients.management.forgotPassword(email),
  });
};

export default useResetPassword;
